
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { string } from "yup";
import FormikControls from "../form-components/FormikControls";

const LoginForm = (props) => {
  const { handleOnSubmit = () => { } } = props;
  const initialValues = {
    code: "",
    username: "",
    password: "",
  };

  const validationSchema = Yup.object({
    code: Yup.string().required("Required"),
    username: string().required("Required"),
    password: string().required("Required"),
  });

  const onSubmit = async (values) => {
    handleOnSubmit(values)
  };
  const focusElemnt = (elementID) => {
    elementID &&
      document.getElementById(elementID) &&
      document.getElementById(elementID).focus();
  };
  const handlekeyDown = (e, nextId, prevId) => {
    if (e.key === "Enter") {
      e.preventDefault();
      focusElemnt(nextId);
    } else if (e.key === "Escape") {
      focusElemnt(prevId);
    }
  };
  return (
    <div className="login--content">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ values, setFieldValue, submitForm }) => {
          return (
            <Form>
              <div className="input--wrapper">
                <FormikControls
                  id="code"
                  control="input"
                  type="text"
                  name="code"
                  label="Enter Code"
                  autoFocus={true}
                  autoComplete="off"
                  style={{ textTransform: "uppercase" }}
                  onKeyDown={(e) =>
                    handlekeyDown(e, "username", "login")
                  }
                />
              </div>
              <div className="input--wrapper">
                <FormikControls
                  id="username"
                  control="input"
                  type="text"
                  name="username"
                  label="Enter Login ID"
                  autoComplete="off"
                  onKeyDown={(e) =>
                    handlekeyDown(e, "password", "code")
                  }
                />
              </div>
              <div className="input--wrapper">
                <FormikControls
                  id="password"
                  control="input"
                  type="password"
                  name="password"
                  label="Enter Password"
                  autoComplete="off"
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      submitForm()
                    } else {
                      handlekeyDown(e, "login", "username")
                    }
                  }
                  }

                />
              </div>
              <button
                id="login"
                className="submit--btn"
                onClick={(e) => {
                  submitForm();
                }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    submitForm();
                  } else {
                    handlekeyDown(e, "code", "password");
                  }
                }}
              >
                LOGIN
              </button>
            </Form>
          );
        }}
      </Formik>
    </div>
  );
};

export default LoginForm;
